import * as React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';

import type { OmitStylesComponentProps } from '../../types';
import { cn } from '../../utils/cn';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

const accordionContentVariants = cva('accordion-content', {
    variants: {
        variant: {
            // motion-reduce drops the height transition and the open/close
            // keyframes for readers who ask for reduced motion; the panel still
            // shows and hides, it just does so without animating.
            default:
                'overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down motion-reduce:transition-none motion-reduce:data-[state=closed]:animate-none motion-reduce:data-[state=open]:animate-none',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

const accordionContentChildVariants = cva('rocco-accordion-content', {
    variants: {
        variant: {
            default: 'pt-0 pb-4',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const AccordionContent = React.forwardRef<
    React.ElementRef<typeof AccordionPrimitive.Content>,
    OmitStylesComponentProps<typeof AccordionPrimitive.Content> &
        VariantProps<typeof accordionContentVariants>
>(({ children, variant, className, ...props }, ref) => (
    <AccordionPrimitive.Content
        ref={ref}
        className={cn(accordionContentVariants({ variant }), className)}
        {...props}
    >
        <div className={accordionContentChildVariants({ variant })}>
            {children}
        </div>
    </AccordionPrimitive.Content>
));

AccordionContent.displayName = AccordionPrimitive.Content.displayName;
